import { useQuery } from '@grandvisionhq/graphql';
import GET_MY_WISHLIST_ID from '../operations/queries/get-my-wishlist-id.js';

const useGetMyWishlistId = ()=>{
    var ref, ref1;
    const { data , loading , error  } = useQuery(GET_MY_WISHLIST_ID, {
        context: {
            // TODO: Make use of the locale property from useIntl once BE supports this.
            // For now We need to pass this with a hardcoded value of 'en', because the BE is unable to handle values like en-GB.
            // https://jira.grandvision.global/browse/MACC-15068
            forwardHeaders: {
                'Accept-Language': 'en'
            }
        }
    });
    var ref2;
    return {
        id: (ref2 = data === null || data === void 0 ? void 0 : (ref = data.me) === null || ref === void 0 ? void 0 : (ref1 = ref.wishlist) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref2 !== void 0 ? ref2 : undefined,
        loading,
        error: error || null
    };
};

export { useGetMyWishlistId };
//# sourceMappingURL=use-get-my-wishlist-id.js.map
